/**
 * Created by xiejs on 2017/6/8
 */

import request from 'mini-ajax';

let fetch = function (opts) {
	return new Promise((rs, rj) => {
		request({
			...opts,
			success(data, xhr) {
				rs(data);
			},
			error(xhr, status, err) {
				rj({
					xhr,
					status,
					err
				});
			},
			onTimeout(err, xhr) {
				rj({
					xhr,
					err
				});
			}
		});
	});
}

fetch.get = function (url, params) {
	return new Promise((rs, rj) => {
		request.get(url, params, function (err, data, xhr) {
			if (err) {
				rj({
					xhr,
					err,
					status: xhr.status
				});
			} else {
				rs(data);
			}
		});
	});
}

fetch.delete = function (url, params) {
	return new Promise((rs, rj) => {
		request.delete(url, params, function (err, data, xhr) {
			if (err) {
				rj({
					xhr,
					err,
					status: xhr.status
				});
			} else {
				rs(data);
			}
		});
	});
}

fetch.post = function (url, params) {
	return new Promise((rs, rj) => {
		request.post(url, params, function (err, data, xhr) {
			if (err) {
				rj({
					xhr,
					err,
					status: xhr.status
				});
			} else {
				rs(data);
			}
		});
	});
}

fetch.put = function (url, params) {
	return new Promise((rs, rj) => {
		request.put(url, params, function (err, data, xhr) {
			if (err) {
				rj({
					xhr,
					err,
					status: xhr.status
				});
			} else {
				rs(data);
			}
		});
	});
}


export default fetch;


// WEBPACK FOOTER //
// ./src/lib/request-promise.js